export default {
  tipoDoc: 'Type de document',
  nroDoc: 'Numéro de document',
  nombres: 'Noms',
  primerAp: 'Prénom',
  segundoAp: 'Deuxième nom de famille',
  telefono: 'Numéro de téléphone mobilel',
  email: 'Courriel electŕonico',
  nacionalidad: 'Nationalité',
  nro_apostilla: 'Nombre d’Apostille',
  cod_seguridad: 'Code de sécurité',
  codigo: 'Code de suivi',
  day: 'Journée',
  month: 'Mois',
  year: 'Année',
  nombre_solicitante: 'Nom du demandeur',
  precio: 'Prix',
  estado: 'ESTADO (fr)',
  fecha_expedicion: 'Date d’émission de l’Apostille',
  fecha_nacimiento: 'Date de naissance',
  fecha_solicitud: 'Fecha de solicitud (fr)',
  docFactura: 'Número de documento',
  tipoFactura: 'Tipo de documento',
  nombreFactura: 'Nombre completo',
  det_tramite: 'Detalles de su trámite (Frances)',
  info_sol: 'DATOS DEL TITULAR DEL DOCUMENTO (fr)',
  info_doc: 'DOCUMENTO(S) (fr)',
  info_pago: 'DATOS DE PAGO (fr)',
  info_finalizado: 'FINALIZADO (fr)',
  info_cont: 'Ingrese sus datos personales y de contacto para recibir notificaciones sobre el estado de su trámite (frances)',
  info_agregar: 'Agregue el/los documento(s) que necesita apostillar (fr)',
  alert_doc: 'Todavía no tiene ningún documento agregado (fr)',
  mis_doc: 'Mis documentos (fr)',
  desc_doc: 'Descripción del/de los documento(s) (fr)',
  select_doc: 'Seleccione un documento para apostillar (fr)',
  doc: 'Documento (fr)',
  docs: 'Documentos (fr)',
  titulo_factura: 'Ingrese sus datos para la factura (fr)',
  datos_pago: 'Verifique los datos de pago. La factura solo cubre el pago de la(s) apostilla(s) (fr)',
  titular_factura: 'Señor(es) (fr)',
  costo_doc: 'Costo de documento(s) (fr)',
  costo_apostilla: 'Costo apostilla(s) (fr)',
  confirmacion_solicitud: '¿Está seguro que quiere realizar su solicitud con estos datos? (fr)',
  confirmar: 'Confirmar (fr)',
  aceptar: 'Aceptar (fr)',
  cancelar: 'Cancelar (fr)',
  fin_solicitud: '¡Su solicitud se ha realizado correctamente! (fr)',
  cod_seguimiento: 'Su código de seguimiento es (fr):',
  guardar_codigo: 'Guarde el código (fr)',
  seguimiento_codigo: ' de seguimiento para ver el estado de su solicitud ingresando  (fr)',
  aqui: 'aquí (fr)',
  ingrese_codigo_seguimiento: 'Ingrese el código de seguimiento para ver el estado de su trámite. (fr)',
  verificar_documento: 'Ingresa la información requerida para poder verificar que el documento se encuentre apostillado. (fr)',
  datos_del_solicitante: 'Datos del solicitante (fr)',
  pago_entidad: 'Pagado en la entidad (fr)',
  pago_cancilleria: 'Pagado en Cancillería (fr)',
  factura_tipo_documento: 'Tipo de documento',
  factura_titular_factura: 'Titular de factura',
  factura_nro_documento: 'Nro. de documento'
};



// WEBPACK FOOTER //
// ./src/lang/fr/fields.js